module.exports = __webpack_public_path__ + "img/chart.d6ca93ca.png";